export default __webpack_public_path__ + "static/media/icon-blue.973a60e2.svg";